import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#let (service \"session\") as |session|}}\n  {{#unless session.user.isLimited}}\n    {{yield}}\n  {{/unless}}\n{{/let}}")